'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SUMMARY = _constantsAnalytics2.default.CATEGORIES.SUMMARY;
var _analyticsConstants$E = _constantsAnalytics2.default.EVENTS,
    ADD_SUMMARY = _analyticsConstants$E.ADD_SUMMARY,
    EDIT_SUMMARY = _analyticsConstants$E.EDIT_SUMMARY,
    REMOVE_SUMMARY = _analyticsConstants$E.REMOVE_SUMMARY;
var _analyticsConstants$A = _constantsAnalytics2.default.ACTIONS,
    ADD_CONTENT = _analyticsConstants$A.ADD_CONTENT,
    EDIT_ITEM = _analyticsConstants$A.EDIT_ITEM,
    REMOVE_CONTENT = _analyticsConstants$A.REMOVE_CONTENT;


function composeSummaryEvent(eventName, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: 1,
    gtmLabel: undefined,
    gtmCategory: SUMMARY,
    gtmAction: action
  });
}

function composeAddSummaryEvent() {
  return (0, _compose.composeAnalytics)([composeSummaryEvent(ADD_SUMMARY, ADD_CONTENT)]);
}

function composeEditSummaryEvent() {
  return (0, _compose.composeAnalytics)([composeSummaryEvent(EDIT_SUMMARY, EDIT_ITEM)]);
}

function composeRemoveSummaryEvent() {
  return (0, _compose.composeAnalytics)([composeSummaryEvent(REMOVE_SUMMARY, REMOVE_CONTENT)]);
}

exports.default = {
  composeAddSummaryEvent: composeAddSummaryEvent,
  composeEditSummaryEvent: composeEditSummaryEvent,
  composeRemoveSummaryEvent: composeRemoveSummaryEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/summariesEventComposer.js
// module id = 588
// module chunks = 0 2 4 5 6 8 9 10 11